/** Un transport HTTP réussi ne suffit pas : les services peuvent retourner un refus métier. */
export function studioCommandFailureMessage(code: string): string | undefined {
  return ({
    'studio.command.replay_regression':'moduleStudio.replay.regression',
    'studio.command.binding_regression':'moduleStudio.replay.regression',
    'spec.regression':'moduleStudio.replay.regression',
    'template.protection_required': 'moduleStudio.designer.review.why.protection.pii',
    'template.rebase_pending': 'moduleStudio.template.rebase.title',
    'studio.command.targets_required': 'moduleStudio.template.error',
    'studio.command.draft_required': 'moduleStudio.template.noDraft',
    'studio.command.stale_version': 'moduleStudio.thread.staleBase',
    'studio.command.declined': 'moduleStudio.command.declined',
    'studio.command.captures_required': 'studio.command.captures_required',
    'reference.protection_review': 'reference.protection_review',
  } as Record<string, string>)[code];
}

export function assertStudioCommandOutcome(key: string, value: unknown, targetVersion?: number): void {
  if (!value || typeof value !== 'object') return;
  type Gate = { state?: string; passed?: boolean };
  const result = value as { status?: string; state?: string; passed?: boolean; qualityGate?: Gate; plan?: { qualityGate?: Gate }; version?: number };
  const gate = key === 'verify' ? result : result.qualityGate ?? result.plan?.qualityGate;
  if (result.status === 'failed' || gate?.state === 'failed' || gate?.passed === false && gate.state !== 'unavailable')
    throw new Error('studio.command.failed');
  // GAP-69 : « Réparer » dépose la proposition réparée sous le numéro suivant (la version visée n'est pas touchée) : N+1 est attendu.
  if (targetVersion !== undefined && ['propose', 'repair', 'accept'].includes(key) && result.version !== undefined && result.version !== targetVersion
    && !(key === 'repair' && result.version === targetVersion + 1))
    throw new Error('studio.command.stale_version');
}

export interface StudioGateDiagnostic { check?: string; code: string; file: string; line: number; message: string }
export interface StudioGateIssue { specVersion: number | null; diagnostics: StudioGateDiagnostic[] }
/** GAP-76 (02.11.2026) : une porte en échec (Livrer / Vérifier) garde ses diagnostics après l'arrêt du plan, avec la version livrée. */
export function studioGateDiagnostics(key: string, value: unknown, targetVersion?: number): StudioGateIssue | null {
  if (!value || typeof value !== 'object') return null;
  type Gate = { state?: string; passed?: boolean; diagnostics?: StudioGateDiagnostic[] };
  const result = value as { specVersion?: number; version?: number; qualityGate?: Gate; plan?: { qualityGate?: Gate } } & Gate;
  const gate = key === 'verify' ? result : result.qualityGate ?? result.plan?.qualityGate;
  if (!gate || !(gate.state === 'failed' || gate.passed === false && gate.state !== 'unavailable')) return null;
  const diagnostics = (gate.diagnostics ?? []).filter(d => d && typeof d.code === 'string' && !d.code.endsWith('_unavailable'));
  return { specVersion: result.specVersion ?? result.version ?? targetVersion ?? null, diagnostics };
}
